import { render } from "./IndividualResults.vue?vue&type=template&id=1621aca4&scoped=true"
import script from "./IndividualResults.vue?vue&type=script&lang=js"
export * from "./IndividualResults.vue?vue&type=script&lang=js"

import "./IndividualResults.vue?vue&type=style&index=0&id=1621aca4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1621aca4"]])

export default __exports__